import { render, staticRenderFns } from "./descFooter.vue?vue&type=template&id=3327dc9f"
import script from "./descFooter.vue?vue&type=script&lang=js"
export * from "./descFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports